module.exports = __webpack_public_path__ + "01_long_gray.b88fcdd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_long_gray.png
// module id = Grck
// module chunks = 0